import { Blockqoute } from './Blockqoute'

export default Blockqoute
